/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Winterinocctemperaturesetpoint3Inputs */



/**
* | output |
* | --- |
* | "Winter unoccupied heating setpoint" |
*
* @param {Ahu_History_Key_Winterinocctemperaturesetpoint3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_winterinocctemperaturesetpoint3 = /** @type {((inputs?: Ahu_History_Key_Winterinocctemperaturesetpoint3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Winterinocctemperaturesetpoint3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Winter unoccupied heating setpoint")
	return /** @type {LocalizedString} */ ("Consigne chaud inoccupation hiver")
});
export { ahu_history_key_winterinocctemperaturesetpoint3 as "ahu_history_key_winterInoccTemperatureSetpoint" }